import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Company from "../../API/APIServices/Company";
import MyContext from "../MyContext";
import Swal from "sweetalert2";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

function ReportTableButton(props) {
  //*********************{Button Script}*********************//
  const navigate = useNavigate();
  const { companyData, UserDetails } = useContext(MyContext);
  const [isHovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const [isHovered1, setHovered1] = useState(false);
  const handleMouseEnter1 = () => {
    setHovered1(true);
  };
  const handleMouseLeave1 = () => {
    setHovered1(false);
  };
  const [isHovered2, setHovered2] = useState(false);
  const handleMouseEnter2 = () => {
    setHovered2(true);
  };
  const handleMouseLeave2 = () => {
    setHovered2(false);
  };
  const [isHovered3, setHovered3] = useState(false);
  const handleMouseEnter3 = () => {
    setHovered3(true);
  };
  const handleMouseLeave3 = () => {
    setHovered3(false);
  };
  const [isHovered4, setHovered4] = useState(false);
  const handleMouseEnter4 = () => {
    setHovered4(true);
  };
  const handleMouseLeave4 = () => {
    setHovered4(false);
  };
  const [isHovered5, setHovered5] = useState(false);
  const handleMouseEnter5 = () => {
    setHovered5(true);
  };
  const handleMouseLeave5 = () => {
    setHovered5(false);
  };
  const [isHovered6, setHovered6] = useState(false);
  const handleMouseEnter6 = () => {
    setHovered6(true);
  };
  const handleMouseLeave6 = () => {
    setHovered6(false);
  };
  const handleBack = () => {
    window.history.back();
  };
  // const [isSearchButton, setSearchButton] = useState(props.isSearchButton);

  const {
    printButton,
    excelButton,
    shareButton,
    createTemplateSetting,
    createData,
  } = props;

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Get the day, month, year, hours, minutes, and AM/PM
    const day = String(date.getDate()).padStart(2, "0"); // Pad single digit day with leading zero
    const month = date.toLocaleString("default", { month: "short" }); // Get abbreviated month name (e.g., "Jan")
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Pad single digit minutes with leading zero
    let ampm = "AM";

    if (hours >= 12) {
      ampm = "PM";
      if (hours > 12) {
        hours -= 12; // Convert 24-hour to 12-hour format
      }
    } else if (hours === 0) {
      hours = 12; // Handle midnight
    }

    // Format as dd Jan yyyy hh:mm AM/PM
    // return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
    return `${day}\u00A0${month}-${year}`;
  }

  // ************************ Print/Pdf *****************************
  const convertData = () => {
    ;
    console.log(props.customStartDate);
    console.log(props.customEndDate);

    if (props.selectedData.length !== 0) {
      if (!props.selectedData.length) {
        return [];
      }
      const fields = Object.keys(props.selectedData[0]);
      const filteredFields = fields.slice(2, -1);

      const sortedData = props.selectedData.sort((a, b) => a["sno"] - b["sno"]);
      // const sortedData = props.data
      //     .map((item, index) => ({ ...item, 'sno': index + 1 }))
      //     .sort((a, b) => a['sno'] - b['sno']);
      const result = [
        filteredFields,
        ...sortedData.map((row) => filteredFields.map((field) => row[field])),
      ];
      return result;
    } else {
      if (!props.data.length) {
        return [];
      }
      // const fields = Object.keys(props.columns[0].Header);
      const normalize = (str) => str.toLowerCase().replace(/\s+/g, "");

      const fields = props.columns.map((col) => col.Header);
      const filteredFields = fields.slice(2, -1); // Skip first 2 and last one

      // Normalize column headers
      const normalizedFields = filteredFields.map(normalize);

      // Generate result table
      const result = [
        filteredFields, // Original headers in row 1
        ...props.data.map((row) =>
          normalizedFields.map((normField, i) => {
            // Match against normalized keys in data row
            const matchKey = Object.keys(row).find(
              (key) => normalize(key) === normField
            );
            return row[matchKey] ?? "";
          })
        ),
      ];

      return result;
    }
  };
  // const generatePDF = () => {
  //     const aoaData = convertData();
  //     const docDefinition = {
  //         content: [
  //             {
  //                 table: {
  //                     headerRows: 1,
  //                     body: aoaData,
  //                 },
  //             },
  //         ],
  //     };
  //     pdfMake.createPdf(docDefinition).open();
  // };

  const printDataToConsole = () => {
    ;
    const aoaData = convertData();
    const [headerRow, ...bodyRows] = aoaData;

    const printWindow = window.open("", "_blank");

    const style = `
    <style>
      * {
        box-sizing: border-box;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 20px;
      }

      .companyData {
        font-size: 18px;
        text-align: center;
        margin-bottom: 7px;
      }

      .listname {
        font-size: 15px;
        text-align: center;
        margin: 5px;
      }

      #printTable {
        border: 1px solid #6e6e6e;
        font-size: 14px;
        border-collapse: collapse;
        width: 95%;
        margin: auto;
      }

      #printTable th, #printTable td {
        border: 1px solid #6e6e6e;
        padding: 5px;
        text-align: center;
      }

      thead {
        background: rgb(93, 116, 173);
        color: white;
        font-size: 11px;
      }

      @media print {
        body {
          margin: 0;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .companyData {
          font-size: 16px;
        }

        .listname {
          font-size: 14px;
        }

        #printTable {
          font-size: 10px;
          width: 90%;
        }

        thead {
          background: rgb(93, 116, 173) !important;
          color: white !important;
        }

        th, td {
          border: 1px solid #6e6e6e;
        }
      }
    </style>
  `;

    // Safely extract values
    const companyName = companyData?.name || "";
    const heading = props?.heading ? `${props.heading} List` : "";
    const partyName = props?.data?.[0]?.partyname || "";
    const partyMobile = props?.data?.[0]?.partymobileno || "";

    // Conditionally render divs
    const headerHtml = `
    ${companyName ? `<div class="companyData">${companyName}</div>` : ""}
    ${heading ? `<div class="listname">${heading}</div>` : ""}
    ${partyName ? `<div class="listname">${partyName}</div>` : ""}
    ${
      partyMobile
        ? `<div class="listname">Mobile No :- ${partyMobile}</div>`
        : ""
    }
    ${
      props.customStartDate && props.customEndDate
        ? `<div class="listname">Bill Date :- ${formatDate(
            props.customStartDate
          )} to ${formatDate(props.customEndDate)}</div>`
        : ""
    }
  `;

    const content = `
    <html>
      <head>
        <title>Print</title>
        ${style}
      </head>
      <body>
        ${headerHtml}
        <table id="printTable">
          <thead>
            <tr>
              ${headerRow.map((cell) => `<th>${cell || ""}</th>`).join("")}
            </tr>
          </thead>
          <tbody>
            ${bodyRows
              .map(
                (row) => `
              <tr>
                ${row.map((cell) => `<td>${cell || ""}</td>`).join("")}
              </tr>`
              )
              .join("")}
          </tbody>
        </table>
      </body>
    </html>
  `;

    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();

    printWindow.onload = function () {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        // printWindow.close();
      }, 500); // Delay for styles and rendering
    };
  };

  // ************************  Excel Sheet *****************************
  //   const convertDataToAOA = () => {
  //     if (props.selectedData.length !== 0) {
  //       if (!props.selectedData.length) {
  //         return [];
  //       }
  //       const fields = Object.keys(props.selectedData[0]);
  //       const filteredFields = fields.slice(2, -1);

  //       const sortedData = props.selectedData.sort((a, b) => a["sno"] - b["sno"]);
  //       const result = [
  //         filteredFields,
  //         ...sortedData.map((row) => filteredFields.map((field) => row[field])),
  //       ];
  //       return result;
  //     } else {
  //       if (!props.data.length) {
  //         return [];
  //       }
  //       const fields = Object.keys(props.data[0]);
  //       const filteredFields = fields.slice(2, -1);

  //       return [
  //         filteredFields,
  //         ...props.data.map((row) => filteredFields.map((field) => row[field])),
  //       ];
  //     }
  //   };

  const handleExportToExcel = () => {
    props.handleDataExport();

    // const Data = convertDataToAOA();
    //     const ws = XLSX.utils.aoa_to_sheet(Data);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    //     const filename = `table_data_${Date.now()}.xlsx`;
    //     XLSX.writeFile(wb, filename);
  };

  const ExcelBtnClick = () => {
    if (UserDetails && UserDetails.canExportReport) {
      handleExportToExcel();
    } else {
      Swal.fire({
        icon: "warning",
        title: "You have not permission to export report!",
        text: "",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",
          confirmButton: "my-confirm-button",
          cancelButton: "my-cancel-button",

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    }
  };

  const [firmName, setFirmName] = useState();
  const [userName, setUserName] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const arrayString = localStorage.getItem("loginUser");
      const arrayToStore = JSON.parse(arrayString);
      setUserName(arrayToStore.userName);
      if (companyData || companyData == "") {
        const data = await Company.GetCompanyById(arrayToStore.compId);
        setFirmName(data.name);
      } else {
        setFirmName(companyData.name);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="panel-head-button">
      <div className="navbar-right">
        {/* {isSearchButton && ( */}
        <div className="Tablebutton5" onClick={props.openModal}>
          <button
            className={`save-button-main-small ${isHovered5 ? "hovered" : ""}`}
            onMouseEnter={handleMouseEnter5}
            onMouseLeave={handleMouseLeave5}
          >
            <i
              id="step-2"
              className="fa-solid fa-magnifying-glass IconFontS1"
            ></i>
            {isHovered5 && (
              <div className="hoverSmallButton">
                <i className="fa-solid fa-sort-up ItemIconHover"></i>
                Search
              </div>
            )}
          </button>
        </div>
        {/* )} */}
        <div className="Tablebutton5">
          <button
            className={`save-button-main-small ${isHovered1 ? "hovered" : ""}`}
            onMouseEnter={handleMouseEnter1}
            onMouseLeave={handleMouseLeave1}
            onClick={() => window.location.reload()}
          >
            <i id="step-2" className="fa-solid fa-rotate IconFontS1"></i>
            {isHovered1 && (
              <div className="hoverSmallButton">
                <i className="fa-solid fa-sort-up ItemIconHover"></i>
                Reset/F8
              </div>
            )}
          </button>
        </div>
        {excelButton == true && (
          <div className="Tablebutton5">
            <button
              className={`save-button-main-small ${
                isHovered2 ? "hovered" : ""
              }`}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
              onClick={ExcelBtnClick}
            >
              <i id="step-2" className="fa-solid fa-file-excel IconFontS1"></i>
              {isHovered2 && (
                <div className="hoverSmallButton">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  XLM/F9
                </div>
              )}
            </button>
          </div>
        )}
        {printButton == true && (
          <div className="Tablebutton5">
            <button
              className={`save-button-main-small ${
                isHovered4 ? "hovered" : ""
              }`} //onClick={props.handleExportToPDF}
              onMouseEnter={handleMouseEnter4}
              onMouseLeave={handleMouseLeave4}
              onClick={printDataToConsole}
            >
              <i id="step-2" className="fa-solid fa-print IconFontS1"></i>
              {isHovered4 && (
                <div className="hoverSmallButton">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Print/F9
                </div>
              )}
            </button>
          </div>
        )}
        {shareButton == true && (
          <div className="Tablebutton5">
            <button
              className={`save-button-main-small ${
                isHovered6 ? "hovered" : ""
              }`}
              onMouseEnter={handleMouseEnter6}
              onMouseLeave={handleMouseLeave6}
            >
              <i id="step-2" className="fa-solid fa-share-nodes IconFontS1"></i>
              {isHovered6 && (
                <div className="hoverSmallButton">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>
                  Share
                </div>
              )}
            </button>
          </div>
        )}

        {((createData && createData !== "/") ||
          (props.PageCreate && props.PageCreate !== "/")) && (
          <Link to={createData || props.PageCreate} className="button-m5">
            <button
              id="SaveBtnMain"
              // onClick={createTemplateSetting}
              className={`save-button-main-save ${isHovered ? "hovered" : ""}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              Create/F2
              {isHovered && (
                <div className="hover-textSave">
                  <i className="fa-solid fa-sort-up ItemIconHover"></i>{" "}
                  Create/F2
                </div>
              )}
            </button>
          </Link>
        )}

        <div onClick={handleBack} className="Tablebutton5">
          <button
            className={`save-button-main ${isHovered3 ? "hovered" : ""}`}
            onMouseEnter={handleMouseEnter3}
            onMouseLeave={handleMouseLeave3}
          >
            <i
              id="step-2"
              className="fa-solid fa-arrow-left-long im-IconRight"
              onClick={handleBack}
            ></i>
            Back/ESC
            {isHovered3 && (
              <div className="hover-textSave">
                <i className="fa-solid fa-sort-up ItemIconHover"></i>
                Back/ESC
              </div>
            )}
          </button>
        </div>

        <div className="loggedInDataDiv">
          <label className="loggedInDataLabel">Hi,{userName}</label>
          <label className="loggedInDataLabel">{firmName}</label>
        </div>
      </div>
    </div>
  );
}

export default ReportTableButton;
